export default "__VITE_ASSET__CYQ08irZ__"